/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiCreateStreemshotRequestFromJSON(json) {
    return StreemApiCreateStreemshotRequestFromJSONTyped(json, false);
}
export function StreemApiCreateStreemshotRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'requestedAt': !exists(json, 'requested_at') ? undefined : (new Date(json['requested_at'])),
        'requestedByUserSid': !exists(json, 'requested_by_user_sid') ? undefined : json['requested_by_user_sid'],
        'requestedByDeviceSid': !exists(json, 'requested_by_device_sid') ? undefined : json['requested_by_device_sid'],
        'requestedForUserSid': !exists(json, 'requested_for_user_sid') ? undefined : json['requested_for_user_sid'],
        'requestedForDeviceSid': !exists(json, 'requested_for_device_sid') ? undefined : json['requested_for_device_sid'],
    };
}
export function StreemApiCreateStreemshotRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'requested_at': value.requestedAt === undefined ? undefined : (value.requestedAt.toISOString()),
        'requested_by_user_sid': value.requestedByUserSid,
        'requested_by_device_sid': value.requestedByDeviceSid,
        'requested_for_user_sid': value.requestedForUserSid,
        'requested_for_device_sid': value.requestedForDeviceSid,
    };
}
//# sourceMappingURL=StreemApiCreateStreemshotRequest.js.map